exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".videoContainer[data-v-2e80cb5e]{position:absolute;top:0;left:0;right:0;bottom:0;width:100%}.leg-button[data-v-2e80cb5e]{font-size:2vw;margin-top:1vw}.modal-footer[data-v-2e80cb5e]{display:none}", ""]);

// exports
